import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Status } from "../../common/constants";
import api from '../../api';
import { RootState } from "../../store";
import { revokePublicApiTokenUrl } from "../../config";  // your DELETE url

const DELETE_TOKEN = "deletePublicApiToken";

interface IDeletePublicApiTokenPayload {
  entryId: string;
  orgId: string;
}

interface IDeletePublicApiTokenResponse {
  message: string;
}

interface IDeletePublicApiTokenState {
  status: string;
  error: string | null;
  msg: string | null;
}

const initialState: IDeletePublicApiTokenState = {
  status: Status.IDLE,
  error: null,
  msg: null,
};

export const deletePublicApiToken = createAsyncThunk(
  DELETE_TOKEN,
  async (payload: IDeletePublicApiTokenPayload, { rejectWithValue }) => {
    try {
      const response = await api.delete<IDeletePublicApiTokenResponse>(
        `${revokePublicApiTokenUrl}?entryId=${payload.entryId}`, {data: {orgId: payload.orgId}}
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

const deletePublicApiTokenSlice = createSlice({
  name: DELETE_TOKEN,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(deletePublicApiToken.pending, (state) => {
        state.status = Status.PENDING;
        state.msg = null;
        state.error = null;
      })
      .addCase(deletePublicApiToken.fulfilled, (state, action) => {
        state.status = Status.SUCCESS;
        state.msg = (action.payload as IDeletePublicApiTokenResponse).message;
      })
      .addCase(deletePublicApiToken.rejected, (state, action) => {
        const errorPayload = action.payload as { response?: { data?: { message?: string } } };
        state.status = Status.FAILED;
        state.error = errorPayload?.response?.data?.message || action.error.message || 'Unknown error';
      });
  },
});

export const selector = (state: RootState) => state.revokePublicApiToken;

export default deletePublicApiTokenSlice.reducer;
